import React from "react";
import "./Landing.scss";
import Intro from "./Intro";

function Landing() {
  return (
    <div>
      <>{<Intro />}</>
    </div>
  );
}

export default Landing;
